import React, { Fragment } from 'react'

import { InputBase, InputLabel, Typography } from '@mui/material'

import { StatusColorInputBase } from './types'
import { useStyles } from './styles'

interface GenericInputActionProps {
  value: string
  onChange:
    | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined
  adornment: JSX.Element
  error?: boolean
  errorText?: string
  status: StatusColorInputBase
  disabled?: boolean
  placeholder: string
  name: string
  onBlur?:
    | React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined
  id?: string
  onKeyPress?: React.KeyboardEventHandler<HTMLDivElement> | undefined
  ref?: React.Ref<JSX.Element> | undefined
  type?: string
  autoFocus?: boolean | undefined
  backgroundColor?: string // Nuevo parámetro
  inputRef?: React.RefObject<HTMLInputElement> | undefined
}

export const GenericInputAction: React.FC<GenericInputActionProps> = ({
  value,
  onChange,
  adornment,
  status,
  error = false,
  errorText = '',
  disabled = false,
  placeholder,
  name,
  onBlur = undefined,
  id = '',
  onKeyPress = undefined,
  ref = undefined,
  type = 'text',
  autoFocus = false,
  backgroundColor,
  inputRef = undefined
}) => {
  const classes = useStyles(status, backgroundColor)()

  return (
    <Fragment>
      <InputBase
        type={type}
        autoComplete='off'
        onBlur={onBlur}
        id={id}
        autoFocus={autoFocus}
        name={name}
        placeholder={placeholder}
        className={`${classes.root} ${classes.status}`}
        inputProps={{
          className: classes.centerText
        }}
        value={value}
        onChange={onChange}
        endAdornment={adornment}
        error
        disabled={disabled}
        onKeyPress={onKeyPress}
        ref={ref}
        inputRef={inputRef}
      />
      {error && (
        <InputLabel id='dia'>
          <Typography style={{ color: 'red', whiteSpace: 'normal', wordWrap: 'break-word' }} variant='button'>
            {errorText}
          </Typography>
        </InputLabel>
      )}
    </Fragment>
  )
}
